// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1cwKj","dialog":"Modal_dialog__8vq09","mobile":"Modal_mobile__2FN3M"};